import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ForcedPasswordReset from './ForcedPasswordReset';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, passwordResetRequired } = useAuth();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        background: '#0f172a'
      }}>
        <div className="spinner"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // P2-A (R6): the D1 rolling reset — the whole app is replaced by the
  // full-screen "Set a new password" step until the server mints clean claims.
  if (passwordResetRequired) {
    return <ForcedPasswordReset />;
  }

  return children;
};

export default ProtectedRoute;
